<div class="host-edit-guest">
  <div class="flex flex-row items-start" [formGroup]="form">
    <div class="v4-layout-form v4-layout-form-vertical w-1/2 pr-3">
      <div class="v4-layout-field">
        <div class="v4-layout-field-label">{{ "modal.add_guest.form.name" | translate }}</div>
        <div class="v4-layout-field-control">
          <input
            type="text"
            nzSize="large"
            nz-input
            [attr.placeholder]="'placeholder.add_guest.name' | translate"
            formControlName="name" />
        </div>
      </div>
      <div class="v4-layout-field">
        <div class="v4-layout-field-label">{{ "modal.add_guest.form.sex" | translate }}</div>
        <div class="v4-layout-field-control">
          <nz-radio-group formControlName="gender">
            <label nz-radio [nzValue]="1">{{ "word.male" | translate }}</label>
            <label nz-radio [nzValue]="2">{{ "word.female" | translate }}</label>
          </nz-radio-group>
        </div>
      </div>
      <div class="v4-layout-field">
        <div class="v4-layout-field-label">{{ "modal.add_guest.form.mobile" | translate }}</div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            @if (isInternational) {
              <div class="mr-[8px] w-[100px]">
                <nz-select
                  #codeSelect
                  class="w-full"
                  nzSize="large"
                  nzShowSearch
                  [(ngModel)]="countryCode"
                  (nzBlur)="onSearchBlur(codeSelect)"
                  [ngModelOptions]="{ standalone: true }"
                  [nzOptions]="listOfCountryCode"
                  [nzDropdownMatchSelectWidth]="false">
                </nz-select>
              </div>
            }
            <input
              class="flex-1"
              type="phone"
              nzSize="large"
              nz-input
              [attr.placeholder]="'placeholder.add_guest.mobile' | translate"
              formControlName="phone" />
          </div>
        </div>
      </div>
      <div class="v4-layout-field">
        <div class="v4-layout-field-label">{{ "modal.add_guest.form.email" | translate }}</div>
        <div class="v4-layout-field-control">
          <input
            type="text"
            nzSize="large"
            nz-input
            [attr.placeholder]="'placeholder.add_guest.email' | translate"
            formControlName="email" />
        </div>
      </div>
      <div class="v4-layout-field">
        <div class="v4-layout-field-label">{{ "modal.add_guest.form.id_type" | translate }}</div>
        <div class="v4-layout-field-control">
          <nz-select
            nzSize="large"
            [nzPlaceHolder]="'placeholder.add_guest.id_type' | translate"
            [nzDropdownMatchSelectWidth]="false"
            formControlName="id_type">
            <nz-option
              *ngFor="let option of idTypeOptions"
              [nzValue]="option.value"
              [nzLabel]="option.key | translate"></nz-option>
          </nz-select>
        </div>
      </div>
      <div class="v4-layout-field">
        <div class="v4-layout-field-label">{{ "modal.add_guest.form.id" | translate }}</div>
        <div class="v4-layout-field-control">
          <input
            type="text"
            nzSize="large"
            nz-input
            [attr.placeholder]="'placeholder.add_guest.id' | translate"
            formControlName="id_number" />
        </div>
      </div>
    </div>
    <div class="v4-layout-form v4-layout-form-vertical w-1/2 pl-3">
      <div class="v4-layout-field">
        <div class="v4-layout-field-label">{{ "modal.add_guest.form.birthday" | translate }}</div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <nz-select formControlName="month" nzSize="large" [nzOptions]="monthOptions"></nz-select>
            <nz-select formControlName="date" class="mx-2" nzSize="large" [nzOptions]="dateOptions"></nz-select>

            <nz-date-picker
              nzSize="large"
              nzMode="year"
              [nzPlaceHolder]="'placeholder.add_guest.birthday' | translate"
              formControlName="year"></nz-date-picker>
          </div>
        </div>
      </div>
      <div class="v4-layout-field">
        <div class="v4-layout-field-label">{{ "modal.add_guest.form.country" | translate }}</div>
        <div class="v4-layout-field-control">
          <nz-select
            nzSize="large"
            [nzPlaceHolder]="'placeholder.add_guest.country' | translate"
            [nzOptions]="countryOptions"
            formControlName="country">
            <!-- <nz-option
              *ngFor="let option of countryOptions"
              [nzValue]="option.alpha2"
              [nzLabel]="option.name"
            ></nz-option> -->
          </nz-select>
        </div>
      </div>
      <div class="v4-layout-field">
        <div class="v4-layout-field-label">{{ "modal.add_guest.form.note" | translate }}</div>
        <div class="v4-layout-field-control">
          <textarea
            rows="5"
            nz-input
            formControlName="comment"
            [attr.placeholder]="'placeholder.add_guest.note' | translate"></textarea>
        </div>
      </div>
      <div class="v4-layout-field">
        <div class="v4-layout-field-label">{{ "modal.add_guest.form.tag" | translate }}</div>
        <div class="v4-layout-field-control">
          <nz-select
            formControlName="client_tags"
            nzSize="large"
            [nzPlaceHolder]="'component-selected_panel_html_添加标签' | translate"
            nzMode="multiple"
            [nzOptions]="tagOptions"
            [nzDropdownRender]="tagFooter"></nz-select>
          <ng-template #tagFooter>
            <nz-divider class="mt-3 mb-3"></nz-divider>
            <div class="px-3 pb-3">
              <a nz-button nzType="link" (click)="toSettingOptionPage()">
                <i nz-icon nzType="setting" nzTheme="outline"></i>
                {{ "order.manage_tag" | translate }}
                <!-- Manage tags -->
              </a>
            </div>
          </ng-template>

          <!-- <host-guest-tag formControlName="client_tags"></host-guest-tag> -->
        </div>
      </div>
      <div class="v4-layout-field">
        <div class="v4-layout-field-label">{{ "modal.add_guest.form.certificate" | translate }}</div>
        <div class="v4-layout-field-control">
          <host-base-image-upload formControlName="client_credential" showBigImg="true"></host-base-image-upload>
        </div>
      </div>
    </div>
  </div>

  <div class="footer flex flex-row items-center justify-between">
    <div class="ml-auto">
      <button class="mr-3" nzSize="large" nz-button (click)="onClickCancel()">{{ "word.cancel" | translate }}</button>
      <button nzSize="large" nz-button nzType="primary" (click)="onClickConfirm()">
        {{ "word.save" | translate }}
      </button>
    </div>
  </div>
</div>
